import React , { Component } from 'react';

import ServiceAdvantageSty from './contentServiceAdvantage.module.css';

import serviceIcon from '../../images/service_icon.png';

import service1 from '../../images/service1.png';
import service2 from '../../images/service2.png';
import service3 from '../../images/service3.png';
import service4 from '../../images/service4.png';
import serviceItemIcon from '../../images/service_description_icon.png';



const menuData=[
    {key:0, itemIcon: serviceIcon, itemTitle:'服务优势'}
];

const contentData=[
    {key:0,itemImg:service1,title:'致诚式服务',description:'为客户精心设计的方案与贴心的实施 操作无缝链接于客户需求',itemIcon:serviceItemIcon},
    {key:1,itemImg:service2,title:'多元化协作',description:'根据客户的要求，利用广泛的协作关系，为客户提供可信赖的专业服务',itemIcon:serviceItemIcon},
    {key:2,itemImg:service3,title:'前瞻性策划',description:'提出合理化建议，及时为客户的发展规避风险、增大利益空间',itemIcon:serviceItemIcon},
    {key:3,itemImg:service4,title:'合理化收费',description:'项目未完成之前不收取任何服务费，保证客户运营零风险，收益最大化',itemIcon:serviceItemIcon},
];

class ContentServiceAdvantage extends Component{

    state={
        showIntroItem:-1
    }

    constructor(props){
        super(props);
        this.conItemOnMouseOver=this.conItemOnMouseOver.bind(this);
        this.conItemOnMouseLeave=this.conItemOnMouseLeave.bind(this);
    }


    conItemOnMouseOver=(index)=>{
        this.setState({
            showIntroItem:index,
        });
    }

    conItemOnMouseLeave=()=>{
        this.setState({
            showIntroItem:-1,
        });
    }


    render(){
        let menuLis=menuData.map(({key,itemIcon,itemTitle})=>{
            return(
                <li key={key}>
                    <div className={ServiceAdvantageSty.menuItemIcon} style={{backgroundImage:`url(${itemIcon})`}}></div>
                    <div className={ServiceAdvantageSty.menuItemTile}>{itemTitle}</div>
                </li>
            );
        });
        

        let contentLis=contentData.map(({key,itemImg,title,description,itemIcon})=>{

            return(
                <li onMouseOver={()=>{this.conItemOnMouseOver(key)}} onMouseLeave={this.conItemOnMouseLeave} key={key}>
                    <div className={ServiceAdvantageSty.conItem} style={{backgroundImage:`url(${itemImg})`}}></div>

                    <div className={ServiceAdvantageSty.conItemIntroDiv} style={{display: this.state.showIntroItem == key? 'block':'none'}}>
                        <div className={ServiceAdvantageSty.introTitle}>{title}</div>
                        <div className={ServiceAdvantageSty.introDescr}>{description}</div>
                        <div className={ServiceAdvantageSty.introItemIcon} style={{backgroundImage:`url(${itemIcon})`}}></div>
                    </div>
                    
                </li>
            );
        });

        return(
            <div className={ServiceAdvantageSty.serviceDiv}>
                <div className={ServiceAdvantageSty.lineDiv}>
                    <div className={ServiceAdvantageSty.menuDiv}>
                        <ul>
                            {menuLis}
                        </ul>
                        {/* <div className={ServiceAdvantageSty.menuMore}><a>更多&gt;&gt;</a></div> */}
                    </div>
                    <div className={ServiceAdvantageSty.splitLine}></div>
                    <div className={ServiceAdvantageSty.contentDiv}>
                        <ul>
                            {contentLis}
                        </ul>
                    </div>
                </div>
            </div>

        );

    }
}

export default ContentServiceAdvantage;